export default "__VITE_ASSET__DhO1Y76z__"